export default {
  hawaiiInsetMapExtent: {
    xmin: -18264475,
    ymin: 1921638,
    xmax: -16827456,
    ymax: 2769173,
    spatialReference: {
      wkid: 102100
    }
  },
  baseExtent: {
    xmin: -13720281,
    ymin: 2120493,
    xmax: -5806107,
    ymax: 7827927,
    spatialReference: {
      wkid: 102100
    }
  },
  // defaultBasemap can be a well-known basemap ID, a custom basemap ID,
  //   or a Portal item (eg  { id: '123...' }
  defaultBasemap: 'nextera-facilities',
  basemaps: ['topo-vector'],
  basemapsWithoutStateOutlines: [], // map click won't select state/province if one of these currently active
  customBasemaps: [
    {
      id: 'nextera-facilities',
      title: 'NextEra Basemap',
      thumbnailUrl: require('../assets/basemaps/next-era.png'),
      baseMapLayers: [
        {
          type: 'vector-tile-layer',
          layerDef: {
            url:
              'https://tiles.arcgis.com/tiles/I77MVaEJQYkpWwzB/arcgis/rest/services/mnc_vector_tiles/VectorTileServer'
          }
        },
        {
          type: 'vector-tile-layer',
          layerDef: {
            portalItem: {
              id: '1768e8369a214dfab4e2167d5c5f2454'
            }
          }
        }
      ]
    },
    {
      id: 'congressional-districts',
      title: 'Congressional Districts',
      thumbnailUrl: require('../assets/basemaps/cong-dist.png'),
      baseMapLayers: [
        {
          type: 'vector-tile-layer',
          layerDef: {
            portalItem: {
              id: '8a2cba3b0ebf4140b7c0dc5ee149549a'
            }
          }
        },
        {
          type: 'feature-layer',
          layerDef: {
            url:
              'https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_116th_Congressional_Districts/FeatureServer/0'
          }
        }
      ]
    }
  ],
  nextEraFacilitiesFeatureLayerDef: {
    id: 'NextEraFacilities',
    url:
      'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/0',
    outFields: ['*'],
    title: 'NextEraFacilities'
  },
  nextEraPipelinesFeatureLayerDef: {
    id: 'NextEraPipelines',
    url:
      'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/3',
    outFields: ['*'],
    title: 'NextEraPipelines'
  },
  nextEraTransmissionFeatureLayerDef: {
    id: 'NextEraTransmission',
    url:
      'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/2',
    outFields: ['*'],
    title: 'NextEraTransmission'
  },
  nextEraLocationsFeatureLayerDef: {
    id: 'NextEraLocations',
    url:
      'https://services5.arcgis.com/I77MVaEJQYkpWwzB/ArcGIS/rest/services/Nextera_Projects/FeatureServer/4',
    outFields: ['*'],
    title: 'NextEraLocations'
  },
  pointPaddingDistance: 1000, // Distance (in meters - Web Mercator) to buffer points when zooming to facility
  mapClickTolerance: 0.005 // Fraction of extent width to buffer point for selecting by map click
};
